import React from "react";

import { Card, CardContent } from "../ui/card";

export default function IntegrationCard({
  title,
  description,
  children,
  icon,
  comingSoon,
}: {
  title: string;
  description?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  comingSoon: boolean;
}) {
  return (
    <Card>
      <CardContent className="gap-4 flex flex-col h-full relative">
        {comingSoon && (
          <div className="absolute -translate-x-1/2 -top-4 left-1/2 @4xl:left-auto @4xl:translate-x-0 @4xl:-top-3 @4xl:-right-10 @4xl:rotate-[35deg] bg-brand p-2 z-10 rounded">
            <p className="font-bold text-sm">Coming soon</p>
          </div>
        )}

        <div className="flex flex-col gap-4 flex-grow">
          <div className="flex flex-row gap-2 justify-between items-center">
            <p className="font-bold">{title}</p>
            {icon && <div className="relative">{icon}</div>}
          </div>
          <p className="text-sm">{description}</p>
        </div>
        {children}
      </CardContent>
    </Card>
  );
}
